{
  "navigation": {
    "current": "Actuel",
    "schedule": "Planifier",
    "tenants": "Locataires",
    "opsCenter": "Centre Ops",
    "hangars": "Hangars",
    "ramps": "Tarmacs",
    "aircraft": "Aéronef",
    "tripSchedule": "Programme du vol",
    "ops": "Ops",
    "feeCalculator": "Calculateur de frais",
    "hangarOptimization": "Calculateur d'optimisation de hangar",
    "help": "Aide",
    "superAdmin": "Super admin",
    "settings": "Paramètres",
    "logout": "Quitter",
    "logoAlt": "Logo AirPLX"
  },
  "timeControl": {
    "prevTrip": "Vol préc.",
    "nextTrip": "Prochain vol",
    "now": "Mnt",
    "today": "Aujourd'hui",
    "daily": "Jour",
    "15m": "15m",
    "previousDay": "Jour précédent",
    "nextDay": "Jour suivant",
    "viewSchedule": "Voir le planning",
    "timeSelectionAriaLabel": "Curseur de sélection de l'heure",
    "tripDurationTitle": "Durée du vol de l'appareil sélectionné",
    "noPreviousTrips": "Aucun vol antérieur",
    "noPreviousTripsForAircraft": "Aucun vol antérieur pour {{tailNumber}}",
    "jumpToPreviousTrip": "Aller au vol précédent",
    "jumpToPreviousTripForAircraft": "Aller au vol précédent pour {{tailNumber}}",
    "noFutureTrips": "Aucun vol à venir",
    "noFutureTripsForAircraft": "Aucun vol à venir pour {{tailNumber}}",
    "jumpToNextTrip": "Aller au vol suivant",
    "jumpToNextTripForAircraft": "Aller au prochain vol pour {{tailNumber}}"
  },
  "tripListDisplay": {
    "noTripsFound": "Aucun vol trouvé",
    "noOwner": "Aucun"
  },
  "bulkApplyFloatingAction": {
    "applyButton": "Valider",
    "message": "Action groupée flottante"
  },
  "dimensionInput": {
    "currentPrefix": "Actuel :",
    "errorMessage": "Dimension non valide",
    "unit": "ft"
  },
  "equipmentTable": {
    "nameHeader": "Nom",
    "lengthHeader": "Longueur",
    "widthHeader": "Largeur",
    "heightHeader": "Hauteur",
    "towBarHeader": "Barre de remorquage",
    "actionsHeader": "Actions",
    "editButton": "Édit.",
    "deleteButton": "Supprimer"
  },
  "obstaclePreview": {
    "title": "Aperçu de l'obstacle",
    "emptyState": "Sélectionnez un obstacle pour l'aperçu",
    "noImageAvailable": "Aucune image disponible",
    "dimensionsLabel": "Dimensions",
    "lengthLabel": "Longueur",
    "widthLabel": "Largeur",
    "heightLabel": "Hauteur",
    "unit": "ft"
  },
  "obstacleTable": {
    "nameHeader": "Nom",
    "lengthHeader": "Longueur",
    "widthHeader": "Largeur",
    "heightHeader": "Hauteur",
    "actionsHeader": "Actions",
    "editButton": "Édit.",
    "deleteButton": "Supprimer"
  },
  "recentPatternsPanel": {
    "title": "Tendances récentes",
    "lastPrefix": "Dern. :",
    "appliedSuffix": "appliqué",
    "never": "Jamais",
    "reApplyButton": "Réappliquer",
    "unknownAircraft": "Aéronef inconnu"
  },
  "vipTagSelect": {
    "label": "Tags",
    "addTag": "Ajouter",
    "editTags": "Modifier",
    "noTags": "Aucun tag"
  },
  "notFoundCard": {
    "hangarTitle": "Hangar introuvable",
    "rampTitle": "Aire de stationnement introuvable",
    "hangarMessage": "Le hangar que vous recherchez n'existe pas ou vous n'y avez plus accès.",
    "rampMessage": "L'aire de stationnement que vous recherchez n'existe pas ou vous n'y avez plus accès.",
    "goToHangars": "Aller aux hangars",
    "goToRamps": "Aller aux aires de stationnement"
  },
  "activation": {
    "title": "Répondre à une vraie question de hangar",
    "subtitle": "5 étapes pour devenir un pro d'AirPlx",
    "steps": {
      "addAircraft": {
        "title": "Ajouter un autre aéronef",
        "description": "Ajouter un locataire à votre hangar"
      },
      "firstAutostack": {
        "title": "Lancer AutoStack",
        "description": "Laissez l'algorithme organiser vos aéronefs"
      },
      "secondAutostack": {
        "title": "Essayer un autre scénario",
        "description": "Relancer AutoStack avec un autre appareil"
      },
      "saveFavorite": {
        "title": "Enregistrer la vue",
        "description": "Créer un favori pour le retrouver plus tard"
      },
      "shareLayout": {
        "title": "Partager avec votre équipe",
        "description": "Imprimer, copier le lien ou envoyer par e-mail"
      },
      "runAutostack": "Continuer"
    },
    "progress": "{{completed}} sur {{total}} terminé",
    "dismiss": "Ignorer pour l'instant",
    "completed": "Terminé",
    "complete": {
      "title": "Vous êtes prêt !",
      "message": "Vous avez terminé la configuration. AirPlx est prêt à vous aider à planifier.",
      "dismiss": "Compris"
    }
  }
}
